console.log("PRODUCT ADDON FILE VERSION 6");

// These listeners are delegated on document and read the DOM fresh on every
// event, so they stay correct even after the size-switcher's AJAX section
// swap replaces the addon cards / variant-picker with new elements. They
// only need to be registered ONCE for the whole page lifetime -- attaching
// them again on every initProductAddons() re-run would double (or triple)
// count every qty-plus/qty-minus click.
if (!window.__productAddonGlobalListenersInit) {
window.__productAddonGlobalListenersInit = true;

document.addEventListener("click", function (e) {
if (e.target.classList.contains("qty-plus")) {
const input = e.target.previousElementSibling;
if (input) input.value = parseInt(input.value) + 1;
}
if (e.target.classList.contains("qty-minus")) {
const input = e.target.nextElementSibling;
if (input && parseInt(input.value) > 0) {
input.value = parseInt(input.value) - 1;
}
}
});

document.addEventListener("click", function (e) {
const addToCartBtn = e.target.closest(".m-add-to-cart");
if (addToCartBtn && typeof window.updateAddonVariants === "function") {
window.updateAddonVariants();
}
});

document.addEventListener("variant:changed", function () {
if (typeof window.updateAddonVariants === "function") window.updateAddonVariants();
if (typeof window.updateAddonModelVisibility === "function") window.updateAddonModelVisibility();
});
}

function initProductAddons() {

let productData = null;
let variants = [];

if (window._themeProducts) {
const productId = Object.keys(window._themeProducts)[0];
productData = window._themeProducts[productId];
if (productData && productData.variants) {
variants = productData.variants;
}
}

function getSelected(optionName, scope = document) {
const el = scope.querySelector(`input[name="${optionName}"]:checked`);
return el ? el.value : null;
}

function getOptionIndex(optionName) {
if (!productData || !productData.options) return null;
const idx = productData.options.findIndex(o => o.name === optionName);
return idx === -1 ? null : idx;
}

function getVariantOptionValue(variant, optionName) {
const idx = getOptionIndex(optionName);
if (idx === null) return null;
return variant[`option${idx + 1}`];
}

function sizedImageUrl(src, size) {
return src.replace(/(\.jpg|\.png|\.webp)/, `_${size}x$1`);
}

function updateConfigurationSwatches() {
if (!variants.length) return;
const selectedFabric = getSelected("Fabric");
const selectedModel = getSelected("Model");
if (!selectedFabric) return;

const configIndex = getOptionIndex("Configuration");
if (configIndex === null) return;

const configLabels = document.querySelectorAll(
`[data-option-position="${configIndex + 1}"] .m-product-option--node__label`
);

configLabels.forEach(label => {
const configurationValue = label.textContent.trim();
const variant = variants.find(v => {
const matchesConfig = getVariantOptionValue(v, "Configuration") === configurationValue;
const matchesFabric = getVariantOptionValue(v, "Fabric") === selectedFabric;
const matchesModel = !selectedModel || getVariantOptionValue(v, "Model") === selectedModel;
return matchesConfig && matchesFabric && matchesModel;
});
if (!variant || !variant.featured_image) return;
const image = sizedImageUrl(variant.featured_image.src, 300);
label.style.backgroundImage = `url(${image})`;
});
}

function updateAddonModelVisibility() {
const selectedModel = getSelected("Model");
document.querySelectorAll(".product-addon-item[data-addon-model]").forEach(item => {
const matches = !selectedModel || item.dataset.addonModel === selectedModel;
item.classList.toggle("addon-model-hidden", !matches);
});
}

function updateAddonVariants() {
const addonItems = document.querySelectorAll(".product-addon-item");

addonItems.forEach((addonContainer) => {
const addonVariantInput = addonContainer.querySelector('.addon-variant-id');
const addonQtyInput = addonContainer.querySelector('.addon-quantity');
const addonPriceEl = addonContainer.querySelector('.addon-price');
const addonImgEl = addonContainer.querySelector('.configurator-upgrade-card__img');
const jsonEl = addonContainer.querySelector(".addon-product-json");
if (!jsonEl) return;

const addonData = JSON.parse(jsonEl.textContent);

let matchingVariant = addonData.variants.find(v => {
return addonData.options.every((optionName, i) => {
let selectedInput = addonContainer.querySelector(`input[name="${optionName}"]:checked`);
let selectedValue = selectedInput ? selectedInput.value : null;

if (!selectedValue) {
const hasOwnRadios = addonContainer.querySelector(`input[name="${optionName}"]`);
if (hasOwnRadios) return true;
// Prefer the live checked radio on the main product: the checked state is
// already updated by the time this change handler runs, whereas the
// variant-picker wrapper's data-selected-value attribute is written by its
// own separate change listener and can still hold the PREVIOUS value at
// this point -- that ordering bug is what made the addon color lag one
// click behind the selected Fabric. Fall back to the wrapper attribute
// only when there's no live radio to read (e.g. dropdown pickers).
selectedValue = getSelected(optionName);
if (!selectedValue) {
const mainVariantEl = document.querySelector(`variant-picker [data-option-name="${optionName}"]`);
selectedValue = mainVariantEl ? mainVariantEl.getAttribute('data-selected-value') : null;
}
if (!selectedValue) return true;
}
return v[`option${i + 1}`] === selectedValue;
});
});

if (!matchingVariant) matchingVariant = addonData.variants[0];

if (matchingVariant) {
addonVariantInput.value = matchingVariant.id;
if (addonQtyInput) addonQtyInput.dataset.variant = matchingVariant.id;
if (addonPriceEl) {
if (window.Shopify && Shopify.formatMoney) {
addonPriceEl.textContent = Shopify.formatMoney(matchingVariant.price);
} else {
addonPriceEl.textContent = "$" + (matchingVariant.price / 100).toFixed(2);
}
}
// Swap the card photo to the matched variant's own image (e.g. Clay vs
// Haze vs Juniper) so the Addon cards visually track the Fabric color
// selected on the main sofa, not just the underlying cart variant/price.
if (addonImgEl && matchingVariant.featured_image && matchingVariant.featured_image.src) {
const src300 = sizedImageUrl(matchingVariant.featured_image.src, 300);
const src600 = sizedImageUrl(matchingVariant.featured_image.src, 600);
addonImgEl.src = src300;
addonImgEl.srcset = `${src300} 1x, ${src600} 2x`;
}
}
});
}

// Expose these so the global (registered-once) listeners above, and any
// external code such as the size-switcher's AJAX swap, can trigger a resync
// without needing a closure reference.
window.updateAddonVariants = updateAddonVariants;
window.updateAddonModelVisibility = updateAddonModelVisibility;

document.querySelectorAll(".product-addon-item").forEach(container => {
container.querySelectorAll(".addon-fabric-radio").forEach(radio => {
radio.addEventListener("change", function () {
updateAddonVariants();
});
});
});

const fabricInputs = document.querySelectorAll('input[name="Fabric"]');
fabricInputs.forEach(input => {
input.addEventListener("change", function () {
setTimeout(updateConfigurationSwatches, 100);
});
});

const mainVariantPicker = document.querySelector('variant-picker');
if (mainVariantPicker) {
mainVariantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
input.addEventListener("change", function () {
updateAddonVariants();
updateAddonModelVisibility();
setTimeout(updateConfigurationSwatches, 100);
});
});
}

updateConfigurationSwatches();
updateAddonModelVisibility();
setTimeout(updateAddonVariants, 800);
}

document.addEventListener("DOMContentLoaded", initProductAddons);
document.addEventListener("theme:section:reload", initProductAddons);
window.initProductAddons = initProductAddons;
